import { createFileRoute } from '@tanstack/react-router'
import { BoardView } from '@/features/task-boards/board-view'

export const Route = createFileRoute(
  '/_authenticated/_organization/tasks/boards/$boardId'
)({
  component: BoardView,
})
